module.exports = __webpack_public_path__ + "img/Pic_PDA_DOWN.8fbeebcc.png";